import React from "react";
import SidebarList from "./SidebarList";
import {
  AppTopNavi,
  Button,
  Icon,
  Input,
  Menu,
  MenuItem,
  MenuItemDivider,
  Popup,
  Tooltip,
  WithPopup,
  WithTooltip,
} from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../../utilities/Constants";
import { Translation } from "react-i18next";
import SidebarForm from "./SidebarForm";
import {
  ABB_CHECK_MARK,
  ABB_CLOSE,
  ABB_COPY,
  ABB_NEW,
  ABB_REPORT,
} from "../../../utilities/IconConstants";
import scannerActions from "../../../flux/actions/ScannerAction";
import scannerListStore from "../../../flux/stores/scanner/ListStore";
import { IScannerViewData } from "../../../models/scanner/ScannerViewData";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../../models/shared/SidebarDetail";
import Authorize from "../../../utilities/Authorize";
import authUtility from '../../../utilities/AuthUtility';

interface ISidebar { }
interface ISidebarProps {
  authKey?: string;
  // side bar collapse function
  onCollapseSidebar: () => void;
  // search value
  searchValue: string;
  // search functionality
  onSearch: (e: any) => void;

  onCreateClick: (e: any) => void;
  onScannerClick: (e: any) => void;

  viewAll: (e: any) => void;

  cloneClick: (e: any) => void;
  showSelectFilterHandler?: () => void;

  /*======================*/
  setName?: (val: string) => void;
  inputName?: any;
  onActivate?: () => void;
  isShowPopup?: boolean;
  onSave?: (e: any, val: boolean) => void;
  onDeactivate?: () => void;
  module?: string;
  setCode?: (val: string) => void;
  inputCode?: any;
  isShowCodeInput?: boolean;
  nameError?: boolean;
  codeError?: boolean;
  isButtonDisabled?: boolean;
  /*======================*/
  showFilter?: boolean;
  hasFiltersChanged?: boolean;
  isShowSelectFilter?: boolean;
  reSet?: () => void;
  status?: boolean;
  onCopy?: (e: any, val: boolean) => void;
  sortArray?: () => void;
  isShowSort?: boolean;
  sortOrder?: number;
  isSorted?: boolean;
}

interface IState {
  isSampleWithScanner: boolean;
  listData: any;
}
export default class Sidebar extends React.Component<ISidebarProps, IState> {
  private _listData: any = [];
  constructor(props: any) {
    super(props);
    this.state = {
      isSampleWithScanner: false,
      listData: [],
    };
  }

  onScanner = () => {
    this.setState({ isSampleWithScanner: !this.state.isSampleWithScanner });
  };

  componentDidMount() {
    this.getAllScannerData();
    scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._listData = [];
      const data = state.data.result as IScannerViewData[];
      const items: ISidebarDetail[] = [];
      data.forEach((element) => {
        items.push(new SidebarDetail(element.id, element.name));
      });
      this._listData = items;
    });
  }

  getAllScannerData = () => {
    scannerActions
      .getAll(1, 0, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "%20")
      .then(() => {
        this.setState({
          listData: this._listData,
        });
      })
      .catch((e) => console.log("Error ", e));
  };

  render() {
    console.log(this.props, "status");
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="sidebar">
              <div className="container px-3 mb-2">
                <ul className="row nav sidebar-icons px-0">
                  <li className=" nav-item justify-content-center icon-hover" onClick={this.props.onCollapseSidebar}>
                    <button title={t("Collapse")}>
                      <Icon
                        name="abb/caret-left"
                        className="cursor-pointer"
                        sizeClass="large"
                        onClick={this.props.onCollapseSidebar}
                      />
                    </button>
                  </li>
                  <Authorize scopes={[`${this.props.authKey}:Add`]}>
                    <li className=" nav-item justify-content-center icon-hover" onClick={this.props.onCreateClick}>
                      <button title={t("Create")}>
                        <Icon
                          name="abb/plus"
                          className="cursor-pointer"
                          sizeClass="medium"
                          style={{ cursor: "pointer" }}
                          onClick={this.props.onCreateClick}
                        />
                      </button>
                    </li>
                  </Authorize>
                  <Authorize scopes={[`${this.props.authKey}:Scan`]}>
                    <li className=" nav-item justify-content-center icon-hover">
                      <button title={t("Scan")}>
                        <Icon
                          name="abb/qr-code"
                          className="cursor-pointer"
                          sizeClass="medium"
                          style={{ cursor: "pointer" }}
                          onClick={this.onScanner}
                        />
                      </button>
                    </li>
                  </Authorize>

                  {this.state.isSampleWithScanner && (
                    <div className="ul-class">
                      <Menu
                        onLostFocus={() =>
                          this.setState({ isSampleWithScanner: false })
                        }
                        style={{ top: "40px", left: "60px" }}
                      >

                        {this.state.listData.map((d: any, i: any) => {
                          return (
                            <MenuItem
                              key={i}
                              text={d.name}
                              onSelect={() => this.props.onScannerClick(d.id)}
                            />
                          );
                        })}
                      </Menu>
                    </div>
                  )}
                  {authUtility.hasPermission([`${this.props.authKey}:Clone`, `${this.props.authKey}:Copy`]) &&
                    <li className=" nav-item justify-content-center icon-hover">
                      <button title={t("Clone")}>
                        <Icon
                          name="abb/copy"
                          className="cursor-pointer"
                          sizeClass="medium"
                          onClick={this.props.onActivate}
                        />
                      </button>
                    </li>}
                  <Authorize scopes={[`${this.props.authKey}:ViewAll`]}>
                    <li
                      className=" nav-item justify-content-center icon-hover"
                      style={{ cursor: "pointer" }}
                    >
                      <button title={t("View All")}>
                        <Icon
                          name="abb/list"
                          className="cursor-pointer"
                          sizeClass="medium"
                          onClick={this.props.viewAll}
                        />
                      </button>
                    </li>
                  </Authorize>
                </ul>

                <div className="text-center cursor my-1">
                  <WithPopup>
                    <div
                      className={
                        this.props.isShowPopup ? "ml-5 float-left" : null
                      }
                    ></div>
                    <Popup
                      className="popup-align-box"
                      trigger="controlled"
                      position="bottom center"
                      show={this.props.isShowPopup}
                      defaultOpen={false}
                      closeOnLostFocus={true}
                      onClose={() => this.props.onDeactivate()}
                    >
                      <p>
                        <Input
                          // tslint:disable-next-line: no-unused-expression
                          inputAttributes={{ autoFocus: "true" }}
                          onKeyUp={(e) => this.props.onSave(e, true)}
                          className={
                            this.props.nameError ? "error-code mt-2" : "mt-2"
                          }
                          dataType="text"
                          label={
                            t(this.props.module) + " " + t(CONSTANTS.LABLE_NAME)
                          }
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          maxLength={250}
                          value={String(this.props.inputName)}
                          onValueChange={(val: string) =>
                            this.props.setName(val)
                          }
                          showValidationBarWhenInvalid={this.props.nameError}
                          description={
                            this.props.nameError
                              ? this.props.inputName.length
                                ? t(CONSTANTS.INSTRUMENT_NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </p>

                      <div>
                        {
                          <Authorize scopes={[`${this.props.authKey}:Clone`]}>
                            <WithTooltip>
                              <Button
                                type="discreet-blue"
                                shape="rounded"
                                icon={ABB_NEW}
                                className="border border-primary mt-2"
                                onClick={() => this.props.onSave(null, true)}
                                style={{ marginLeft: 5 }}
                              />
                              <Tooltip>
                                <p>{t("New")}</p>
                              </Tooltip>
                            </WithTooltip>
                          </Authorize>
                        }
                        <Authorize scopes={[`${this.props.authKey}:Copy`]}>
                          <WithTooltip>
                            <Button
                              type="discreet-blue"
                              shape="rounded"
                              icon={ABB_REPORT}
                              className="border border-primary mt-2"
                              onClick={() => this.props.onCopy(null, true)}
                              style={{ marginLeft: 35, marginRight: 35 }}
                              disabled={this.props.status}
                            />

                            <Tooltip>
                              <p>{t("Copy")}</p>
                            </Tooltip>
                          </WithTooltip>
                        </Authorize>
                        <WithTooltip>
                          <Button
                            type="discreet-blue"
                            shape="rounded"
                            icon={ABB_CLOSE}
                            className="border border-primary mt-2"
                            onClick={this.props.onDeactivate}
                            style={{ marginLeft: 5 }}
                          />
                          <Tooltip>
                            <p>{t("Cancel")}</p>
                          </Tooltip>
                        </WithTooltip>
                      </div>
                    </Popup>
                  </WithPopup>
                  <div className="clearfix" />
                </div>
                <div className="row pr-2">
                  <div className="col-6 px-0 position-relative">
                    <Input
                      type="normal"
                      inputAttributes={{ autoFocus: "true" }}
                      dataType="text"
                      placeholder={t(CONSTANTS.LABEL_SEARCH)}
                      icon="abb/search"
                      value={this.props.searchValue}
                      onValueChange={this.props.onSearch}
                    />
                  </div>

                  <div className="col-1">
                  {((!this.props.showFilter && this.props.hasFiltersChanged) || this.props.isSorted) && (
                      <Icon
                        name="abb/close"
                        sizeClass="small"
                        onClick={this.props.reSet}
                        style={{ padding: "4px" }}
                      />
                    )}
                  </div>
                  <div className="col-1">
                    {this.props.isShowSort ? (<>
                      {this.props.sortOrder === 1 ? (<WithTooltip><Icon
                        name="abb/down"
                        sizeClass="small"
                        onClick={this.props.sortArray}
                        style={{ padding: "4px", cursor: "pointer" }}
                      /><Tooltip>{t("Sort")}</Tooltip></WithTooltip>) : this.props.sortOrder === 2 || this.props.sortOrder === 0 ? (<WithTooltip><Icon
                        name="abb/up"
                        sizeClass="small"
                        onClick={this.props.sortArray}
                        style={{ padding: "4px", cursor: "pointer" }} /><Tooltip>{t("Sort")}</Tooltip></WithTooltip>) : null}
                    </>): null}
                  </div>
                  <div className="col-2 mt-1">
                    {this.props.isShowSelectFilter ? (
                      <Authorize scopes={[`${this.props.authKey}:Filters`]}>
                        <WithTooltip>
                        <div>
                          {this.props.hasFiltersChanged && (
                            <span className="dots"></span>
                          )}
                          <Icon
                            className={
                              this.props.showFilter
                                ? "filter-circle pointer"
                                : "pointer"
                            }
                            name="abb/filter"
                            sizeClass="small"
                            onClick={this.props.showSelectFilterHandler}
                          />
                        </div>
                        <Tooltip>{t("Filter")}</Tooltip>
                        </WithTooltip>
                      </Authorize>
                    ) : null}
                  </div>
                </div>
              </div>
              {this.props.children}
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
